import { useEffect } from 'react';

/**
 * Automatically logs out the user after `timeout` ms of no interaction.
 * @param {Function} setAuth  Setter from App.js for isAuthenticated.
 * @param {number} timeout    Idle timeout in milliseconds (default 30 min).
 */
export default function useIdleLogout(setAuth, timeout = 30 * 60 * 1000) {
  useEffect(() => {
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        // perform logout
        localStorage.removeItem('authenticated');
        setAuth(false);
        window.location.href = '/auth';
      }, timeout);
    };

    // List of user events that count as “activity”
    const events = ['mousemove','mousedown','keydown','scroll','touchstart'];

    // Attach listeners
    events.forEach(evt => window.addEventListener(evt, resetTimer));

    // Start the first timer
    resetTimer();

    // Cleanup
    return () => {
      clearTimeout(timer);
      events.forEach(evt => window.removeEventListener(evt, resetTimer));
    };
  }, [setAuth, timeout]);
}
